
import * as z from 'zod';
import { PaymentMethodType } from '@/types';

export const addAuthorSchema = z.object({
  name: z.string().min(2, { message: 'Name must be at least 2 characters.' }),
  email: z.string().email({ message: 'Please enter a valid email address.' }),
  phone: z.string().optional(),
  address: z.string().optional(),
  taxPercentage: z.coerce.number().min(0).max(100).default(0),
  paymentMethod: z.object({
    type: z.enum(['check', 'bank_transfer_international', 'bank_transfer_us', 'paypal'] as const),
    threshold: z.coerce.number().min(0),
  }),
  paymentDetails: z.object({
    paypalEmail: z.string().optional(),
    bankName: z.string().optional(),
    accountNumber: z.string().optional(),
    routingNumber: z.string().optional(),
    swift: z.string().optional(),
    address: z.string().optional(),
  }).optional(),
});

export type FormData = z.infer<typeof addAuthorSchema>;
